import { render, staticRenderFns } from "./FormularioAssinaturaDigital.vue?vue&type=template&id=a598c06a&scoped=true&"
import script from "./FormularioAssinaturaDigital.vue?vue&type=script&lang=ts&"
export * from "./FormularioAssinaturaDigital.vue?vue&type=script&lang=ts&"
import style0 from "./FormularioAssinaturaDigital.vue?vue&type=style&index=0&id=a598c06a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a598c06a",
  null
  
)

export default component.exports